import React, { useRef, useEffect, useState } from "react";

import EsriMap from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
// import ImageryLayer from '@arcgis/core/layers/ImageryLayer';
import ImageryTileLayer from "@arcgis/core/layers/ImageryTileLayer";
import BaseTileLayer from "@arcgis/core/layers/BaseTileLayer";
import BaseDynamicLayer from "@arcgis/core/layers/BaseDynamicLayer";
import TileInfo from "@arcgis/core/layers/support/TileInfo";
import Extent from "@arcgis/core/geometry/Extent";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";
import * as watchUtils from "@arcgis/core/core/watchUtils";
import RasterFunction from "@arcgis/core/layers/support/RasterFunction";
import MosaicRule from "@arcgis/core/layers/support/MosaicRule";
import DimensionalDefinition from "@arcgis/core/layers/support/DimensionalDefinition";
import Basemap from "@arcgis/core/Basemap";
import VectorTileLayer from "@arcgis/core/layers/VectorTileLayer";
import TileLayer from "@arcgis/core/layers/TileLayer";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import RasterStretchRenderer from "@arcgis/core/renderers/RasterStretchRenderer";
import Color from "@arcgis/core/Color";
import AlgorithmicColorRamp from "@arcgis/core/rest/support/AlgorithmicColorRamp";
import Swipe from "@arcgis/core/widgets/Swipe";
import Graphic from "@arcgis/core/Graphic";
import Expand from "@arcgis/core/widgets/Expand";
import Legend from "@arcgis/core/widgets/Legend";
import MultipartColorRamp from "@arcgis/core/rest/support/MultipartColorRamp";

import Histogram from "./components/chart/PixelHistogram";
import TimeSeriesLine from "./components/chart/TimeSeriesLine";
import InfoButton from "./components/modal/InfoButton";
import MapClickConfirm from "./components/modal/MapClickConfirm";

import * as d3 from "d3";
import { scaleLinear, scaleDiverging } from "d3-scale";

import "./App.css";
import CaLogo from "./styles/CALogo-new.png";
import legend_map1_temperature from "./styles/legend_map1_temperature.png";
import legend_map1_precipitation from "./styles/legend_map1_precipitation.png";

import config from "./config/config.json"

// URLS
// tiled imagery layers with multidimensional info Per model and individual years, and with 1 band
const TEMPERATURE_URL_SINGLE_MODEL_YEARLY = config.TEMPERATURE_URL_SINGLE_MODEL_YEARLY
const PRECIPITATION_URL_SINGLE_MODEL_YEARLY = config.PRECIPITATION_URL_SINGLE_MODEL_YEARLY

// tiled imagery layers with multidimensional info , and with 150 bands
const TEMPERATURE_URL_SINGLE_MODEL_YEARLY_150_BANDS = config.TEMPERATURE_URL_SINGLE_MODEL_YEARLY_150_BANDS
const PRECIPITATION_URL_SINGLE_MODEL_YEARLY_150_BANDS = config.PRECIPITATION_URL_SINGLE_MODEL_YEARLY_150_BANDS  

// tiled imagery layers with multidimensional info Per model and rolling 30-year average, and with 1 band
const TEMPERATURE_URL_SINGLE_MODEL_AVG = config.TEMPERATURE_URL_SINGLE_MODEL_AVG  
const PRECIPITATION_URL_SINGLE_MODEL_AVG = config.PRECIPITATION_URL_SINGLE_MODEL_AVG  

// tiled imagery layers with multidimensional info Per model and rolling 30-year average, and with 120 bands
const TEMPERATURE_URL_SINGLE_MODEL_AVG_120_BANDS = config.TEMPERATURE_URL_SINGLE_MODEL_AVG_120_BANDS  
const PRECIPITATION_URL_SINGLE_MODEL_AVG_120_BANDS = config.PRECIPITATION_URL_SINGLE_MODEL_AVG_120_BANDS  

// tiled imagery layers for 10 model ensemble
// (Histotric Baseline 1961-1990 = 1975, Mid-Century 2035-2064 = 2049, End of Century 2070-2099 = 2084)
const TEMPERATURE_URL_10_MODEL_ENSEMBLE = config.TEMPERATURE_URL_10_MODEL_ENSEMBLE  
const PRECIPITATION_URL_10_MODEL_ENSEMBLE = config.PRECIPITATION_URL_10_MODEL_ENSEMBLE  

// tiled imagery layers for 4 model ensemble (average of the 4 models in a 30-year moving average) - with 1 band
// layer starts at ( 1964 , -189388800000.0 ) and ends at (2084, 3597523200000.0)
const TEMPERATURE_URL_4_MODEL_ENSEMBLE = config.TEMPERATURE_URL_4_MODEL_ENSEMBLE  
const PRECIPITATION_URL_4_MODEL_ENSEMBLE = config.PRECIPITATION_URL_4_MODEL_ENSEMBLE  

// tiled imagery layers for 4 model ensemble (average of the 4 models in a 30-year moving average), and with 120 bands
const TEMPERATURE_URL_4_MODEL_ENSEMBLE_120_BANDS = config.TEMPERATURE_URL_4_MODEL_ENSEMBLE_120_BANDS  
const PRECIPITATION_URL_4_MODEL_ENSEMBLE_120_BANDS = config.PRECIPITATION_URL_4_MODEL_ENSEMBLE_120_BANDS  

const TEMPERATURE_RENDER_RANGE_MAX = 300;
const TEMPERATURE_RENDER_RANGE_MIN = -300;

const PRECIPITATION_RENDER_RANGE_MAX = 300; //18
const PRECIPITATION_RENDER_RANGE_MIN = -300; //-18

const setupMap = (container) => {
  let basemap = new Basemap({
    baseLayers: [
      new VectorTileLayer({
        url: "https://cdn.arcgis.com/sharing/rest/content/items/5e9b3685f4c24d8781073dd928ebda50/resources/styles/root.json",
        title: "Dark Gray Base",
      }),
    ],
    referenceLayers: [
      new VectorTileLayer({
        url: "https://cdn.arcgis.com/sharing/rest/content/items/747cb7a5329c478cbe6981076cc879c5/resources/styles/root.json",
        title: "Dark Gray Reference"
      })
    ],
    title: "Dark Gray Canvas",
    id: "basemap",
  });

  let worldHillShade = new TileLayer({
    title: "World Hillshade",
    url: "https://services.arcgisonline.com/arcgis/rest/services/Elevation/World_Hillshade/MapServer",
    maxScale: 70.531074,
    blendMode: "multiply",
  });

  // let caDropShadow = new MapImageLayer({
  //   url: "https://caloes-ags.esriemcs.com/arcgis/rest/services/California_Drop_Shadow/MapServer",
  let caDropShadow = new TileLayer({
    url: "https://tiles.arcgis.com/tiles/BLN4oKB0N1YSgvY8/arcgis/rest/services/California_Drop_Shadow/MapServer",
    opacity: 0.5,
    title: "California_Drop_Shadow",
  });

  let map = new EsriMap({
    basemap,
    layers: [worldHillShade, caDropShadow], // [caDropShadow, worldHillShade, imgLayer],
  });

  var view = new MapView({
    container: container,
    map: map,
  });

  return view;
};

const createRenderer = (mode, rasterMin, rasterMax, lesserMinVal, greaterMaxVal) => {  
  let renderer;

  if (mode <= 2) {
    // temperature    
    let mcr =  new MultipartColorRamp({
      colorRamps: [
        new AlgorithmicColorRamp({
            algorithm: "hsv",
            fromColor: new Color([40, 146, 199, 255]), // blue
            toColor: new Color([250, 250, 100, 255]), // yellow
          }),
          new AlgorithmicColorRamp({
              algorithm: "hsv",
              fromColor: new Color([250, 250, 100, 255]), // yellow
              toColor: new Color([232, 16, 20, 255]), //red
            })        
      ]
    })
    
    renderer = new RasterStretchRenderer({
      colorRamp: mcr,
      computeGamma: false,
      dynamicRangeAdjustment: false,
      gamma: [0.6],      
      statistics: [
        [
          lesserMinVal, greaterMaxVal, (lesserMinVal + greaterMaxVal)/2,
          (greaterMaxVal - lesserMinVal)/3.464  // √12 = 3.464
        ],
      ],
      useGamma: true,
      stretchType: "min-max",
      type: "raster-stretch",
      outputMin: 255 * (rasterMin - lesserMinVal)/(greaterMaxVal - lesserMinVal), 
      outputMax: 255 * (rasterMax - lesserMinVal)/(greaterMaxVal - lesserMinVal) 
    });
  } else {
    // precipitation
    let mcr =  new MultipartColorRamp({
      colorRamps: [
        new AlgorithmicColorRamp({
            algorithm: "hsv",
            fromColor: new Color([250, 250, 100, 255]), // yellow
            toColor: new Color([40, 146, 199, 255]), // blue
          }),
          new AlgorithmicColorRamp({
              algorithm: "hsv",
              fromColor: new Color([40, 146, 199, 255]), // blue
              toColor: new Color([12, 16, 120, 255]), //dark blue
            })        
      ]
    })

    renderer = new RasterStretchRenderer({
      colorRamp: mcr,
      computeGamma: false,
      dynamicRangeAdjustment: false,
      gamma: [1],
      maxPercent: 0.25,
      minPercent: 0.25,
      statistics: [
        [
          lesserMinVal, greaterMaxVal, (lesserMinVal + greaterMaxVal)/2,
          (greaterMaxVal - lesserMinVal)/3.464  // √12 = 3.464
        ],
      ],
      useGamma: true,
      stretchType: "percent-clip",
      type: "raster-stretch",
      outputMin: 255 * (rasterMin - lesserMinVal)/(greaterMaxVal - lesserMinVal),
      outputMax: 255 * (rasterMax - lesserMinVal)/(greaterMaxVal - lesserMinVal)
    });
  }

  return renderer;
};

const variableListSelect = (refVal, defaultVal) => {
  return (
    <calcite-select 
      title="Select a climate variable"
      aria-label="Select a climate variable"
      ref={refVal} style={{ width: "100%" }}>
      <calcite-option label="">Select a value</calcite-option>
      <calcite-option
        label={"Maximum Temperature"}
        value={"average maximum"}
        selected={defaultVal === "average maximum"}
      >
        Maximum Temperature
      </calcite-option>
      <calcite-option
        label={"Minimum Temperature"}
        value={"average minimum"}
        selected={defaultVal === "average minimum"}
      >
        Minimum Temperature
      </calcite-option>
      <calcite-option
        label={"Average Precipitation"}
        value={"average precipitation"}
        selected={defaultVal === "average precipitation"}
      >
        Average Precipitation
      </calcite-option>
    </calcite-select>
  );
};

const scenarioListSelect = (refVal, defaultVal) => {
  //TO DO - read dynamically
  return (
    <calcite-select 
      title="Select a climate scenario"
      aria-label="Select a climate scenario"
      ref={refVal} style={{ width: "100%" }}>
      <calcite-option label="Select a value" value="">
        Select a value
      </calcite-option>
      <calcite-option
        label="RCP 4.5"
        value="RCP 4.5"
        selected={defaultVal === "RCP 4.5"}
      >
        RCP 4.5
      </calcite-option>
      <calcite-option
        label="RCP 8.5"
        value="RCP 8.5"
        selected={defaultVal === "RCP 8.5"}
      >
        RCP 8.5
      </calcite-option>
    </calcite-select>
  );
};

const modelListSelect = (refVal, defaultVal) => {
  //TO DO - read dynamically
  return (
    <calcite-select 
      title="Select a climate model or ensemble"
      aria-label="Select a climate model or ensemble"
      ref={refVal} style={{ width: "100%" }}>
      <calcite-option label={"Select a value"} value="">
        Select a value
      </calcite-option>
      <calcite-option-group label="Ensemble Results">
        <calcite-option
          label={"10-model Ensemble"}
          value={"10 MODEL ENSEMBLE"}
          selected={defaultVal === "10 MODEL ENSEMBLE"}
        />
        <calcite-option
          label={"4-model Ensemble"}
          value={"4 MODEL ENSEMBLE"}
          selected={defaultVal === "4 MODEL ENSEMBLE"}
        />
      </calcite-option-group>
      <calcite-option-group label="Rolling Average Results">
        <calcite-option
          label={"CanESM2"}
          value={"CanESM2 Avg"}
          selected={defaultVal === "CanESM2 Avg"}
        />
        <calcite-option
          label={"CNRM-CM5"}
          value={"CNRM-CM5 Avg"}
          selected={defaultVal === "CNRM-CM5 Avg"}
        />
        <calcite-option
          label={"HadGEM2-ES"}
          value={"HadGEM2-ES Avg"}
          selected={defaultVal === "HadGEM2-ES Avg"}
        />
        <calcite-option
          label={"MIROC5"}
          value={"MIROC5 Avg"}
          selected={defaultVal === "MIROC5 Avg"}
        />
      </calcite-option-group>

      <calcite-option-group label="Individual Year Results">
        <calcite-option
          label={"CanESM2"}
          value={"CanESM2"}
          selected={defaultVal === "CanESM2"}
        />
        <calcite-option
          label={"CNRM-CM5"}
          value={"CNRM-CM5"}
          selected={defaultVal === "CNRM-CM5"}
        />
        <calcite-option
          label={"HadGEM2-ES"}
          value={"HadGEM2-ES"}
          selected={defaultVal === "HadGEM2-ES"}
        />
        <calcite-option
          label={"MIROC5"}
          value={"MIROC5"}
          selected={defaultVal === "MIROC5"}
        />
      </calcite-option-group>
    </calcite-select>
  );
};

const years10ModelEnsemble = (defaultVal) => {
  // const vals = [['1975 (1961-1990)', 157766400000],
  //               ['2049 (2035-2064)', 2493072000000],
  //               ['2084 (2070-2099)', 3597523200000]
  //               ]
  const vals = [
    ["Historic Baseline (1961-1990)", 157766400000],
    ["Mid-Century (2035-2064)", 2493072000000],
    ["End of Century (2070-2099)", 3597523200000],
  ];
  
  let elems = vals.map((item) => {
    return (
      <calcite-option
        value={item[1]}
        text-label={item[0]}
        key={item}
        selected={defaultVal === item[1]}
      >
        {item[0]}
      </calcite-option>
    );
  });

  return [
    <calcite-option-group
      label="Named Climate Periods"
      key="key 10 Model Ensemble"
    >
      {elems}
    </calcite-option-group>
  ];
};

const years4ModelEnsemble = (defaultVal) => {
  // use below syntax so that value in milliseconds is same as in the image layer
  // new Date(Date.UTC(year,0,1,0,0,0,0)).valueOf()

  // eg  -631152000000 => Sun Jan 01 1950 00:00:00

  // this layer had dates from 1964 to 2084
  let years = [];
  for (let i = 1964; i <= 2084; i++) {
    years.push([i, new Date(Date.UTC(i, 0, 1, 0, 0, 0)).valueOf()]);
  }

  let elems = years.map((item) => {
    return (
      <calcite-option
        value={item[1]}
        text-label={item[0]}
        key={item}
        selected={defaultVal === item[1]}
      >
        {item[0] + " (30 Year Average)" }
      </calcite-option>
    );
  });

  return [
    <calcite-option-group
      label="30 Year Rolling Average"
      key="key 4 Model Ensemble"
    >
      {elems}
    </calcite-option-group>,
  ];
};

const yearsSingleModelIndividualYears = (defaultVal) => {
  // use below syntax so that value in milliseconds is same as in the image layer
  // new Date(Date.UTC(year,0,1,0,0,0,0)).valueOf()

  // eg  -631152000000 => Sun Jan 01 1950 00:00:00

  // [1950, -631152000000], [1951, -599616000000], [1952, -568080000000]
  // [1969, -31536000000], [1970, 0], [1971, 31536000000]
  // [2098, 4039372800000], [2099, 4070908800000]

  let years = [];
  for (let i = 1950; i <= 2099; i++) {
    years.push([i, new Date(Date.UTC(i, 0, 1, 0, 0, 0)).valueOf()]);
  }

  let elems = years.map((item) => {
    return (
      <calcite-option
        value={item[1]}
        text-label={item[0]}
        key={item}
        selected={defaultVal === item[1]}
      >
        {item[0] + " (Single Year)"}
      </calcite-option>
    );
  });

  return [
    <calcite-option-group
      label="Single Year"
      key="key Single Model Yearly"
    >
      {elems}
    </calcite-option-group>,
  ];
};

const yearsSingleModelAvg30Years = (defaultVal) => {
  // use below syntax so that value in milliseconds is same as in the image layer
  // new Date(Date.UTC(year,0,1,0,0,0,0)).valueOf()

  // eg  -631152000000 => Sun Jan 01 1950 00:00:00

  // this layer has years from 1964 to 2084
  let years = [];
  for (let i = 1964; i <= 2084; i++) {
    years.push([i, new Date(Date.UTC(i, 0, 1, 0, 0, 0)).valueOf()]);
  }

  let elems = years.map((item) => {
    return (
      <calcite-option
        value={item[1]}
        text-label={item[0]}
        key={item}
        selected={defaultVal === item[1]}
      >
        {item[0] + " (30 Year Average)"}
      </calcite-option>
    );
  });

  return [
    <calcite-option-group
      label="30 year rolling average"
      key="key Single Model Average"
    >
      {elems}
    </calcite-option-group>,
  ];
};

const kelvinToFahrenheit = (kelvinVal) => {
  // For Kelvin value of 'x'
  // (x − 273.15) × 9/5 + 32 = val in °F
  return Number(((kelvinVal - 273.15) * (9 / 5) + 32).toFixed(3));
};

const kelvinToCelsius = (kelvinVal) => {
  // For Kelvin value of 'x'
  // x − 273.15 = val in °C
  return Number((kelvinVal - 273.15).toFixed(3));
};

function App() {
  // Create a symbol for drawing the point
  const pinTextSymbol = {
    type: "text",
    color: "#000",
    text: "\ue61d", // esri-icon-map-pin
    font: {
      size: 20,
      family: "CalciteWebCoreIcons",
    },
  };
  
  const colorRampWidth = 27
  const colorRampHeight = 84
  const colorRampStartX = 10
  const colorRampStartY = 15

  const mapDiv1 = useRef(null);
  const mapDiv2 = useRef(null);
  const mapDiv3 = useRef(null);

  let allViews = useRef([]);

  const imgLyr1 = useRef(null);
  const imgLyrView1 = useRef(null);

  const imgLyr2 = useRef(null);
  const imgLyrView2 = useRef(null);

  const imgLyr3 = useRef(null);

  const imgLyr_SingleModelYearly_150Bands = useRef(null);
  const imgLyr_SingleModelAvg_120Bands = useRef(null);
  const imgLyr_4ModelEnsemble_120Bands = useRef(null);

  const scenarioSelection1 = useRef(null);
  const scenarioSelection2 = useRef(null);

  const modelSelection1 = useRef(null);
  const modelSelection2 = useRef(null);

  const variableSelection = useRef(null);

  const timeSelection1 = useRef(null);
  const timeSelection2 = useRef(null);

  const temperatureUnitSelection = useRef(null);

  const renderRangeMax = useRef(TEMPERATURE_RENDER_RANGE_MAX);
  const renderRangeMin = useRef(TEMPERATURE_RENDER_RANGE_MIN);

  // const multidimInfo1 = useRef({});
  // const multidimInfo2 = useRef({});

  const yearsDropdown10ModelEnsemble = useRef(null);
  yearsDropdown10ModelEnsemble.current = years10ModelEnsemble();

  const yearsDropdown4ModelEnsemble = useRef(null);
  yearsDropdown4ModelEnsemble.current = years4ModelEnsemble(-189388800000);

  const yearsDropdownSingleModelIndividual = useRef(null);
  yearsDropdownSingleModelIndividual.current =
    yearsSingleModelIndividualYears();

  const yearsDropdownSingleModelAverage = useRef(null);
  yearsDropdownSingleModelAverage.current =
    yearsSingleModelAvg30Years(-189388800000);

  const resetMapLayers = useRef(false);
  const initialDefaultMultidimInfo = useRef("");

  const variableChanged = useRef(false);
  const scenario1Changed = useRef(false);
  const scenario2Changed = useRef(false);
  const model1Changed = useRef(false);
  const model2Changed = useRef(false);
  const year1Changed = useRef(false);
  const year2Changed = useRef(false);
  const temperatureUnitChanged = useRef(false);

  // 1= Max Temp, 2- Min Temp, 3= Precip
  const selectedVariable = useRef([1, "average maximum"]);

  const selectedScenario1 = useRef("");
  const selectedScenario2 = useRef("");

  // ID will be:  1 = single model yearly, 2 =  single model average, 4 = 4 model , 10 = 10 model
  // format is [model ID, model text value]
  const selectedModel1 = useRef([]);
  const selectedModel2 = useRef([]);

  // format is [year value in millisec, year label]
  const selectedYear1 = useRef([]);
  const selectedYear2 = useRef([]);

  // Fahrenheit and Celsius
  const selectedTemperatureUnit = useRef("F"); // or 'C'

  const clickedMapPoint = useRef(null);

  const resetYear1SelectionAfterRevert = useRef(false);
  const resetYear2SelectionAfterRevert = useRef(false);
  
  const ctx_1 = useRef(null)
  const ctx_2 = useRef(null)
  
  const updateDynamicLegend = useRef(true)
  const legend1 = useRef(null)

  const [selectedPixelValue1, setSelectedPixelValue1] = useState(0.0);
  const [selectedPixelValue2, setSelectedPixelValue2] = useState(0.0);

  const [applyInitialComparison, setApplyInitialComparison] = useState(false);

  const [applyTimeSelectionEvent1, setApplyTimeSelectionEvent1] =
    useState(false);
  const [applyTimeSelectionEvent2, setApplyTimeSelectionEvent2] =
    useState(false);

  const [chartData, setChartData] = useState([]);
  const [timeSeriesChartData, setTimeSeriesChartData] = useState({});
  const [timeSeriesChartUpdating, setTimeSeriesChartUpdating] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  // store changes when modelValue changes
  const [dateDropdownValues1, setDateDropdownValues1] = useState([]);
  const [dateDropdownValues2, setDateDropdownValues2] = useState([]);

  const [compareButtonDisable, setCompareButtonDisable] = useState(true);

  const [disableTemperatureUnit, setDisableTemperatureUnit] = useState(false);

  const [showMapClickDialog, setShowMapClickDialog] = useState(false);

  // Custom layer for comparison
  const ImageryComparisonLayer = BaseDynamicLayer.createSubclass({
    load: async function () {
      const loadPromise = Promise.all([
        this.preLayer.load(),
        this.postLayer.load(),
      ]);
      this.addResolvingPromise(loadPromise);
    },
    // layer properties
    properties: {
      // layers to compare
      preLayer: null,
      postLayer: null,

      // temperature or precipitation
      mode: 1,
      temperatureUnit: "F",

      // functions to get color values
      newScaledRedPixelValue: null,
      newScaledBluePixelValue: null,
      newScaledGreenPixelValue: null,
      newScaledNegRedPixelValue: null,

      // true - when layer 1 or 2 was updated , false - hovering over chart
      getTilesData: false,

      // for histogram chart
      // if cursor is hovering over histogram column
      isHistogramHover: false,
      //array of objects - each object has diff and color (for all Tiles)
      histogramValuesForTiles: [],

      // array of arrays - eacy internal array has [pixel number, diff value, rgb string]
      pixelDataForChartHover: [],

      hoverRange: {},
    },

    fetchImage: async function (extent, width, height, options) {
      // console.log(" fetch " + width + "," + height)
      // console.log(extent.center.x + " , " + extent.center.y)

      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      canvas.width = width;
      canvas.height = height;
      const imageData = context.createImageData(width, height);
      const data = imageData.data;

      // the filter or extent for layers 1 or 2 were changed - get new tiles
      // and pixels to recalc rendering
      if (this.getTilesData) {
        const fetch1 = this.preLayer.fetchPixels(
          extent,
          width,
          height,
          options || {}
        );
        const fetch2 = this.postLayer.fetchPixels(
          extent,
          width,
          height,
          options || {}
        );
        const [pixelData1, pixelData2] = await Promise.all([fetch1, fetch2]);

        // Array of elevation values
        if (!(pixelData1?.pixelBlock && pixelData2?.pixelBlock)) {
          return;
        }
        // console.log("pixelData1 " + pixelData1.pixelBlock.pixels[0].length + "," +  pixelData1.pixelBlock.validPixelCount)

        const {
          pixels: [layer1_pixels],
          mask: layer1_mask,
        } = pixelData1.pixelBlock;
        const {
          pixels: [layer2_pixels],
          mask: layer2_mask,
        } = pixelData2.pixelBlock;

        const multiplier = 30;
        this.histogramValuesForTiles = [];
        this.pixelDataForChartHover = [];
        // for debug
        // let tempVals = [];
        // let transformedValues = {};

        for (let i = 0; i < width * height; i++) {
          if (
            (!layer1_mask || layer1_mask[i]) &&
            (!layer2_mask || layer2_mask[i])
          ) {
            let pixelVal1, pixelVal2;
            if (this.mode <= 2) {
              // temperature
              pixelVal1 =
                this.temperatureUnit === "F"
                  ? kelvinToFahrenheit(layer1_pixels[i])
                  : kelvinToCelsius(layer1_pixels[i]);
              pixelVal2 =
                this.temperatureUnit === "F"
                  ? kelvinToFahrenheit(layer2_pixels[i])
                  : kelvinToCelsius(layer2_pixels[i]);
            } else {
              // precipitation
              pixelVal1 = layer1_pixels[i];
              pixelVal2 = layer2_pixels[i];
            }

            let diff = 0.0;
            diff = Number((pixelVal2 - pixelVal1).toFixed(3));

            // console.log("Kelvin unit " + layer1_pixels[i] + "," + layer2_pixels[i] + "," + Number((layer2_pixels[i] - layer1_pixels[i]).toFixed(3)))
            // console.log(this.temperatureUnit + " unit " + pixelVal1 + "," + pixelVal2 + "," + diff)

            // console.log(layer2_pixels[i] + " - " + layer1_pixels[i] + " = " +  diff + " , " + (layer1_pixels[i] - layer2_pixels[i]).toFixed(3))
            // for debug
            // tempVals.push(diff)

            let newPixelDivergingVal;
            if (diff > 0) {
              // second map pixel value is higher

              // transform the difference to a value between 0 and 1 using 'newScaledRedPixelValue'
              // and then get the rgb value
              if (this.mode <= 2) {
                // temperature - positive values are red
                newPixelDivergingVal = d3.interpolateReds(
                  this.newScaledRedPixelValue(diff * multiplier)
                );
              } else {
                // precipitation - positive values are green
                newPixelDivergingVal = d3.interpolateGreens(
                  this.newScaledGreenPixelValue(diff * multiplier)
                );
              }
            } else if (diff < 0) {
              if (this.mode <= 2) {
                // temperature - negative values are blue

                // transform the difference to a value between 0 and 1
                const scaledBluePixelVal = this.newScaledBluePixelValue(
                  diff * multiplier
                );

                // reverse the blue scale , so colder the temp - the more blue it is
                newPixelDivergingVal = d3.interpolateBlues(
                  1 - scaledBluePixelVal
                );
              } else {
                // precipitation - negative values are red
                const scaledNegRedPixelVal = this.newScaledNegRedPixelValue(
                  diff * multiplier
                );

                // reverse the scale , more dry it is - the more red it is
                newPixelDivergingVal = d3.interpolateReds(
                  1 - scaledNegRedPixelVal
                );
              }
            } else if (diff === 0) {
              // gray for zero diff pixel
              newPixelDivergingVal =   "rgb(172,172,172)" // "rgb(224, 224, 224)"
            }

            // for debug purpose
            // if  (!(diff.toString() in transformedValues)) transformedValues[diff.toString()] = [(diff * multiplier), newPixelDivergingVal]
            
            // newPixelDivergingVal ia a string like this "rgb(242, 239, 238)"
            // get rgb values
            if (newPixelDivergingVal) {
              let rgbArr = newPixelDivergingVal.slice(4, -1).split(",");

              // create RGBA value for the pixel
              data[i * 4] = rgbArr[0]; // red
              data[i * 4 + 1] = rgbArr[1]; // green
              data[i * 4 + 2] = rgbArr[2]; // blue
              data[i * 4 + 3] = 255; // alpha value - in this case, between 0 and 255(fully opaque)

              this.histogramValuesForTiles.push({
                y: diff,
                color: newPixelDivergingVal,
              });
              this.pixelDataForChartHover.push([
                i,
                diff,
                newPixelDivergingVal,
              ]);
            }            
          }
        }
        // only update legend when layer is first created - not for pan/zoom
        if (updateDynamicLegend.current) {
          updateDifferenceLegend()
          updateDynamicLegend.current = false
        }
        
        // update histogram
        setChartData([...this.histogramValuesForTiles]);
      } else {
        // No filter or extent changes to layers 1 or 2 - only apply hover changes
        if (this.isHistogramHover) {
          // highlight the pixels differences from histogram hover
          this.pixelDataForChartHover.forEach((element) => {
            let i = element[0];
            // change color if value falls within hover range
            if (
              element[1] >= this.hoverRange.min &&
              element[1] <= this.hoverRange.max
            ) {
              // create RGBA value for the pixel
              data[i * 4] = 0; // red
              data[i * 4 + 1] = 255; // green
              data[i * 4 + 2] = 255; // blue
              data[i * 4 + 3] = 255; // alpha value - in this case, between 0 and 255(fully opaque)
            } else {
              // just keep existing value

              let rgbArr = element[2].slice(4, -1).split(",");

              // create RGBA value for the pixel
              data[i * 4] = rgbArr[0]; // red
              data[i * 4 + 1] = rgbArr[1]; // green
              data[i * 4 + 2] = rgbArr[2]; // blue
              data[i * 4 + 3] = 255; // alpha value - in this case, between 0 and 255(fully opaque)
            }
          });
        } else {
          // revert to previous rendering
          if (
            this.pixelDataForChartHover &&
            this.pixelDataForChartHover.length > 0
          ) {
            this.pixelDataForChartHover.forEach((element) => {
              let i = element[0];
              let rgbArr = element[2].slice(4, -1).split(",");

              // create RGBA value for the pixel
              data[i * 4] = rgbArr[0]; // red
              data[i * 4 + 1] = rgbArr[1]; // green
              data[i * 4 + 2] = rgbArr[2]; // blue
              data[i * 4 + 3] = 255; // alpha value - in this case, between 0 and 255(fully opaque)
            });
          }
        }
      }

      context.putImageData(imageData, 0, 0);
      return canvas;
    },
  });

  useEffect(() => {
    let active;

    const syncViews = (source) => {
      if (!active || !active.viewpoint || active !== source) {
        return;
      }

      for (const view of allViews.current) {
        if (view !== active) {
          view.viewpoint = active.viewpoint;
        }
      }
    };

    if (allViews.current.length === 2) {
      for (const view of allViews.current) {
        view.watch(["interacting", "animation"], () => {
          active = view;
          syncViews(active);
        });

        view.watch("viewpoint", () => syncViews(view));
      }
    }
  }, [allViews.current]);

  // temporary workarounbd
  useEffect(() => {
    // there must be a better way to do this !
    // only call once to update layer first time with default values
    // since setting default values does not call event handler
    if (!applyTimeSelectionEvent1) {
      if (
        timeSelection1.current &&
        timeSelection1.current.childNodes.length > 0
      ) {
        // let firstNode = Array.from(timeSelection1.current.childNodes)[3]
        let firstNode = timeSelection1.current.childNodes[0].firstChild; //get item within calcite-select
        firstNode.attributes.selected.value = "true"
        selectedYear1.current = [
          firstNode.attributes.value.value,
          firstNode.attributes.getNamedItem('text-label').value
        ];
        setApplyTimeSelectionEvent1(true);
      }
    }

    if (!applyTimeSelectionEvent2) {
      if (
        timeSelection2.current &&
        timeSelection2.current.childNodes.length > 0
      ) {
        let lastNode = timeSelection2.current.childNodes[0].lastChild;
        lastNode.attributes.selected.value = "true"
        selectedYear2.current = [
          lastNode.attributes.value.value,
          lastNode.attributes.getNamedItem('text-label').value,
        ];
        setApplyTimeSelectionEvent2(true);
      }
    }

    if (!applyInitialComparison) {
      if (
        Array.from(scenarioSelection1.current.children).find(
          (el) => el.attributes?.selected?.value === "true"
        ) &&
        Array.from(modelSelection1.current.children)[1].children[0]
          .attributes?.selected?.value === "true" && // hardcode default child index for now
        timeSelection1.current.childNodes.length > 0 &&
        Array.from(timeSelection1.current.childNodes[0]?.childNodes).find(
          (el) => el.attributes?.selected?.value === "true"
        ) &&
        Array.from(scenarioSelection2.current.children).find(
          (el) => el.attributes?.selected?.value === "true"
        ) &&
        Array.from(modelSelection2.current.children)[1].children[0]
          .attributes?.selected?.value === "true" && // hardcode default child index for now
        timeSelection2.current.childNodes.length > 0 &&
        Array.from(timeSelection2.current.childNodes[0]?.childNodes).find(
          (el) => el.attributes?.selected?.value === "true"
        ) &&
        Array.from(variableSelection.current.children).find(
          (el) => el.attributes?.selected?.value === "true"
        )
      ) {
        initialDefaultMultidimInfo.current = "Maximum_Temperature_RCP_4.5";
        onCompareButtonClicked();
        initialDefaultMultidimInfo.current = "";
        setApplyInitialComparison(true);
      }
    }
  });

  useEffect(() => {
    const arrGroups1 = Array.from(modelSelection1.current.children);
    for (let i = 0; i < arrGroups1.length; i++) {
      // when accessing the default value
      let grps = arrGroups1[i];
      let selNode = Array.from(grps.children).find(
        (el) => el.attributes.selected?.value === "true"
      );
      if (selNode) {
        setDateDropdownValues1(
          retrieveDateDropdownValues(selNode.attributes.value.value)
        );
        break;
      }
    }

    const arrGroups2 = Array.from(modelSelection2.current.children);
    for (let i = 0; i < arrGroups2.length; i++) {
      // when accessing the default value
      let grps = arrGroups2[i];
      let selNode = Array.from(grps.children).find(
        (el) => el.attributes.selected?.value === "true"
      );
      if (selNode) {
        setDateDropdownValues2(
          retrieveDateDropdownValues(selNode.attributes.value.value)
        );
        break;
      }
    }
  }, []);

  // need to access the dom node to set custom event listeners or props that aren't strings / numbers
  // https://stenciljs.com/docs/react#properties-and-events
  // Event Listeners
  useEffect(
    (_) => {
      scenarioSelection1.current.addEventListener(
        "calciteSelectChange",
        (evt) => {
          scenario1Changed.current = true;
          setCompareButtonDisable(false);
        }
      );
    },
    [scenarioSelection1]
  );

  useEffect(
    (_) => {
      scenarioSelection2.current.addEventListener(
        "calciteSelectChange",
        (evt) => {
          scenario2Changed.current = true;
          setCompareButtonDisable(false);
        }
      );
    },
    [scenarioSelection2]
  );

  useEffect(
    (_) => {
      modelSelection1.current.addEventListener("calciteSelectChange", (evt) => {
        model1Changed.current = true;
        year1Changed.current = true;
        setDateDropdownValues1(
          retrieveDateDropdownValues(evt.currentTarget.selectedOption.value)
        );
        setCompareButtonDisable(false);
      });
    },
    [modelSelection1]
  );

  useEffect(
    (_) => {
      modelSelection2.current.addEventListener("calciteSelectChange", (evt) => {
        model2Changed.current = true;
        year2Changed.current = true;
        setDateDropdownValues2(
          retrieveDateDropdownValues(evt.currentTarget.selectedOption.value)
        );
        setCompareButtonDisable(false);
      });
    },
    [modelSelection2]
  );

  useEffect(
    (_) => {
      variableSelection.current.addEventListener(
        "calciteSelectChange",
        (evt) => {
          variableChanged.current = true;
          if (
            evt.currentTarget.selectedOption.value === "average precipitation"
          ) {
            setDisableTemperatureUnit(true);
          } else {
            setDisableTemperatureUnit(false);
          }

          setCompareButtonDisable(false);
        }
      );
    },
    [variableSelection]
  );

  useEffect(
    (_) => {
      timeSelection1.current.addEventListener(
        "calciteSelectChange",
        (evt) => {
          year1Changed.current = true;
          setCompareButtonDisable(false);
        }
      );
    },
    [timeSelection1]
  );

  useEffect(
    (_) => {
      timeSelection2.current.addEventListener(
        "calciteSelectChange",
        (evt) => {
          year2Changed.current = true;
          setCompareButtonDisable(false);
        }
      );
    },
    [timeSelection2]
  );

  useEffect(
    (_) => {
      temperatureUnitSelection.current.addEventListener(
        "calciteRadioButtonGroupChange",
        (evt) => {
          temperatureUnitChanged.current = true;
          setCompareButtonDisable(false);
        }
      );
    },
    [temperatureUnitSelection]
  );
  
  const getVariable = () => {
    let val = null;
    if (variableSelection.current.selectedOption) {
      val = variableSelection.current.selectedOption.value;
    } else {
      // this is run first time - since default value does not call event listener
      let selNode = Array.from(variableSelection.current.children).find(
        (el) => el.attributes.selected?.value === "true"
      );
      val = selNode ? selNode.attributes.value.value : null;
    }

    if (!val) return;

    if (val === "average maximum") {
      return [1, val];
    } else if (val === "average minimum") {
      return [2, val];
    } else if (val === "average precipitation") {
      return [3, val];
    }
  };

  const getScenario = (scenarioSelection) => {
    let val = null;
    if (scenarioSelection.selectedOption) {
      val = scenarioSelection.selectedOption.value;
    } else {
      let selNode = Array.from(scenarioSelection.children).find(
        (el) => el.attributes.selected?.value === "true"
      );
      val = selNode ? selNode.attributes.value.value : "";
    }
    return val;
  };

  const getModel = (modelSelection) => {
    let val = null;
    if (modelSelection.selectedOption) {
      val = modelSelection.selectedOption.value;
    } else {
      const arrGroups = Array.from(modelSelection.children);
      for (let i = 0; i < arrGroups.length; i++) {
        // when accessing the default value
        let grps = arrGroups[i];
        let selNode = Array.from(grps.children).find(
          (el) => el.attributes.selected?.value === "true"
        );
        if (selNode) {
          val = selNode.attributes.value.value;
          break;
        }
      }
    }

    if (!val) return;

    if (val === "10 MODEL ENSEMBLE") {
      return [10, val];
    } else if (val === "4 MODEL ENSEMBLE") {
      return [4, val];
    } else {
      if (val.endsWith(" Avg")) return [2, val];
      else return [1, val];
    }
  };

  const getYear = (timeSelection) => {
    const arrGroups = Array.from(timeSelection.children);
    let selNode = null;
    for (let i = 0; i < arrGroups.length; i++) {
      // when accessing user selected value
      selNode = Array.from(timeSelection.children[i].children).find(
        (el) => el.selected === true
      );

      if (selNode) {
        return [selNode.value, selNode.getAttribute('text-label')];
      } else {
        // when accessing the default value
        // cannot acces text-label/textLabel directly here- use index instead
        selNode = Array.from(timeSelection.children[i].children).find(
          (el) => el.attributes.selected?.value === "true"
        );
        if (selNode)
          return [selNode.attributes.value.value, selNode.attributes.getNamedItem('text-label').value];
      }
    }
  };

  const getTemperatureUnit = () => {
    // when accessing user selected value
    let selNode = Array.from(temperatureUnitSelection.current.children).find(
      (el) => el.children[0]?.children[0]?.checked === true
    );
    if (selNode) {
      return selNode.children[0].children[0].value;
    } else {
      // accessing default value
      selNode = Array.from(temperatureUnitSelection.current.children).find(
        (el) => el.children[0].attributes.checked?.value === "true"
      );
      return selNode.children[0].attributes.value.value;
    }
  };

  const resetMaps = () => {
    renderRangeMax.current =
      selectedVariable.current[0] <= 2
        ? TEMPERATURE_RENDER_RANGE_MAX
        : PRECIPITATION_RENDER_RANGE_MAX;
    renderRangeMin.current =
      selectedVariable.current[0] <= 2
        ? TEMPERATURE_RENDER_RANGE_MIN
        : PRECIPITATION_RENDER_RANGE_MIN;

    setupMaps(
      selectedVariable.current[0],
      selectedModel1.current[0],
      selectedModel2.current[0]
    );
  };

  const updateImageLayer1 = () => {
    let selectedMultidimensionalName1 =
      initialDefaultMultidimInfo.current.length > 0
        ? initialDefaultMultidimInfo.current
        : getMultidimensionalVariable1();

    if (selectedMultidimensionalName1.length > 0 && selectedYear1.current) {
      const filter = [
        {
          variableName: selectedMultidimensionalName1,
          dimensionName: "StdTime",
          values: [Number(selectedYear1.current[0])],
        },
      ];

      imgLyr1.current.multidimensionalDefinition = filter;
    }
  };

  const getMultidimensionalVariable1 = () => {
    if (
      selectedScenario1.current?.length <= 0 ||
      selectedModel1.current[1]?.length <= 0 ||
      selectedVariable.current[1]?.length <= 0
    ) {
      return "";
    }

    // the variable naming convention is different in all layers - workaround to get multidimensional info
    let tmpVariableName = "";
    let tmpModelName = "";
    let tmpScenarioName = "";
    let varVal = selectedVariable.current[1];
    let modelVal = selectedModel1.current[1];

    tmpVariableName =
      varVal === "average maximum"
        ? "Maximum_Temperature_"
        : varVal === "average minimum"
        ? "Minimum_Temperature_"
        : varVal === "average precipitation"
        ? "Average_Precipitation_"
        : "";

    tmpScenarioName =
      selectedScenario1.current === "RCP 4.5"
        ? "RCP_4.5"
        : selectedScenario1.current === "RCP 8.5"
        ? "RCP_8.5"
        : "";

    if (modelVal === "10 MODEL ENSEMBLE" || modelVal === "4 MODEL ENSEMBLE") {
      return `${tmpVariableName}${tmpScenarioName}`;
    } else if (modelVal.endsWith(" Avg")) {
      tmpModelName = modelVal.slice(0, modelVal.length - 4) + "_";
      return `${tmpModelName}${tmpVariableName}${tmpScenarioName}`;
    } else {
      // with spaces for default single-band layer
      return `${modelVal} ${varVal} ${selectedScenario1.current}`; //individual years
    }
  };

  const updateImageLayer2 = () => {
    let selectedMultidimensionalName2 =
      initialDefaultMultidimInfo.current.length > 0
        ? initialDefaultMultidimInfo.current
        : getMultidimensionalVariable2();

    if (selectedMultidimensionalName2.length > 0 && selectedYear2.current) {
      const filter = [
        {
          variableName: selectedMultidimensionalName2,
          dimensionName: "StdTime",
          values: [Number(selectedYear2.current[0])],
        },
      ];

      imgLyr2.current.multidimensionalDefinition = filter;
    }
  };

  const getMultidimensionalVariable2 = () => {
    if (
      selectedScenario2.current?.length <= 0 ||
      selectedModel2.current[1]?.length <= 0 ||
      selectedVariable.current[1]?.length <= 0
    ) {
      return "";
    }

    // the variable naming convention is different in all layers - workaround to get multidimensional info
    let tmpVariableName = "";
    let tmpModelName = "";
    let tmpScenarioName = "";
    let varVal = selectedVariable.current[1];
    let modelVal = selectedModel2.current[1];

    tmpVariableName =
      varVal === "average maximum"
        ? "Maximum_Temperature_"
        : varVal === "average minimum"
        ? "Minimum_Temperature_"
        : varVal === "average precipitation"
        ? "Average_Precipitation_"
        : "";

    tmpScenarioName =
      selectedScenario2.current === "RCP 4.5"
        ? "RCP_4.5"
        : selectedScenario2.current === "RCP 8.5"
        ? "RCP_8.5"
        : "";

    if (modelVal === "10 MODEL ENSEMBLE" || modelVal === "4 MODEL ENSEMBLE") {
      return `${tmpVariableName}${tmpScenarioName}`;
    } else if (modelVal.endsWith(" Avg")) {
      tmpModelName = modelVal.slice(0, modelVal.length - 4) + "_";
      return `${tmpModelName}${tmpVariableName}${tmpScenarioName}`;
    } else {
      // with spaces for default single-band layer
      return `${modelVal} ${varVal} ${selectedScenario2.current}`; //individual years
    }
  };

  const setupMaps = (variableValue, modelValue1, modelValue2) => {
    // keep previous map extent
    let prevExtent = null;
    if (allViews.current.length === 2) {
      prevExtent = allViews.current[0].extent;
    }

    // set up the tiled layers visible in first map (1-band)
    allViews.current = [];
    imgLyr1.current = null;
    imgLyr2.current = null;
    imgLyr3.current = null;

    let imgUrl1,
      imgUrl2 = "";
    switch (variableValue) {
      case 1:
      case 2:
        // temperature
        // load either single model/ 4 model / 10 model layer
        imgUrl1 =
          modelValue1 === 1
            ? TEMPERATURE_URL_SINGLE_MODEL_YEARLY
            : modelValue1 === 2
            ? TEMPERATURE_URL_SINGLE_MODEL_AVG
            : modelValue1 === 4
            ? TEMPERATURE_URL_4_MODEL_ENSEMBLE
            : modelValue1 === 10
            ? TEMPERATURE_URL_10_MODEL_ENSEMBLE
            : "";

        imgUrl2 =
          modelValue2 === 1
            ? TEMPERATURE_URL_SINGLE_MODEL_YEARLY
            : modelValue2 === 2
            ? TEMPERATURE_URL_SINGLE_MODEL_AVG
            : modelValue2 === 4
            ? TEMPERATURE_URL_4_MODEL_ENSEMBLE
            : modelValue2 === 10
            ? TEMPERATURE_URL_10_MODEL_ENSEMBLE
            : "";
        break;
      case 3:
        //precipitation
        // load either single model/ 4 model / 10 model layer
        imgUrl1 =
          modelValue1 === 1
            ? PRECIPITATION_URL_SINGLE_MODEL_YEARLY
            : modelValue1 === 2
            ? PRECIPITATION_URL_SINGLE_MODEL_AVG
            : modelValue1 === 4
            ? PRECIPITATION_URL_4_MODEL_ENSEMBLE
            : modelValue1 === 10
            ? PRECIPITATION_URL_10_MODEL_ENSEMBLE
            : "";

        imgUrl2 =
          modelValue2 === 1
            ? PRECIPITATION_URL_SINGLE_MODEL_YEARLY
            : modelValue2 === 2
            ? PRECIPITATION_URL_SINGLE_MODEL_AVG
            : modelValue2 === 4
            ? PRECIPITATION_URL_4_MODEL_ENSEMBLE
            : modelValue2 === 10
            ? PRECIPITATION_URL_10_MODEL_ENSEMBLE
            : "";
        break;
      default:
      // nothing for now
    }
    
    if (mapDiv1.current) {
      let view1 = setupMap(mapDiv1.current);
      // set prev extent
      if (prevExtent) view1.extent = prevExtent;

      imgLyr1.current = new ImageryTileLayer({
        url: imgUrl1,
        title: "layer1",
      });

      imgLyr2.current = new ImageryTileLayer({
        url: imgUrl2,
        title: "layer2",
      });

      view1.map.layers.addMany([imgLyr1.current, imgLyr2.current], 0);
      
      Promise.all([imgLyr1.current.when() , imgLyr2.current.when()]).then( results => {                          
        // set first time only
        if (!prevExtent) view1.extent = imgLyr1.current.fullExtent;        
                 
        // get values for renderer
        let minVal = Math.min(imgLyr1.current.rasterInfo.statistics[0].min, imgLyr2.current.rasterInfo.statistics[0].min)
        let maxVal = Math.max(imgLyr1.current.rasterInfo.statistics[0].max, imgLyr2.current.rasterInfo.statistics[0].max)
        let modeRenderer1 = createRenderer(variableValue, imgLyr1.current.rasterInfo.statistics[0].min, imgLyr1.current.rasterInfo.statistics[0].max, minVal, maxVal);
        let modeRenderer2 = createRenderer(variableValue, imgLyr2.current.rasterInfo.statistics[0].min, imgLyr2.current.rasterInfo.statistics[0].max, minVal, maxVal);
        imgLyr1.current.renderer = modeRenderer1
        imgLyr2.current.renderer = modeRenderer2
        
        // Legend
        const canvas1Elem = document.createElement("canvas")
        canvas1Elem.setAttribute('id', 'canvas2')
        canvas1Elem.setAttribute('width', '100em')
        canvas1Elem.setAttribute('height', '115em')
        ctx_1.current = canvas1Elem.getContext('2d');      
        createStaticLegend(minVal, maxVal)
        
        let expand1 = new Expand({
          expandIconClass: "esri-icon-legend",
          view: view1,
          content: canvas1Elem
        });
        view1.ui.add(expand1, "top-left");
        
        // when new layers are added ('Compare' is clicked) , need to re-apply pin and timechart after layers are loaded
        if (clickedMapPoint.current) identifyPixel(clickedMapPoint.current);
      })         
      
      view1.whenLayerView(imgLyr1.current).then((lyrVw) => {
        imgLyrView1.current = lyrVw;
      });

      view1.whenLayerView(imgLyr2.current).then((lyrVw) => {
        imgLyrView2.current = lyrVw;
      });

      watchUtils.whenFalse(view1, "updating", (val) => {
        // console.log("whenFalse")
        setIsLoading(false);

        if (imgLyr3.current) {
          imgLyr3.current.getTilesData = true;
          imgLyr3.current.histogramValuesForTiles = [];
          imgLyr3.current.pixelDataForChartHover = [];
          imgLyr3.current.temperatureUnit = selectedTemperatureUnit.current;
          imgLyr3.current.refresh();
        }
      });

      watchUtils.whenTrue(view1, "updating", (val) => {
        // console.log("whenTrue")
        setIsLoading(true);
      });

      view1.on("click", (evt) => handleMapClick(evt));
      
      // legend1.current = new Legend({
      //   view: view1,
      //     layerInfos: [
      //       {
      //         layer: imgLyr1.current,
      //         title: imgLyr1.current.title
      //       }
      //     ]
      // })
      
      // const expandtmp = new Expand({
      //   content: legend1.current, //colorRamp, 
      //   view: view1,
      //   expanded: false
      // })
      // view1.ui.add(expandtmp, "top-left");

      const swipe = new Swipe({
        leadingLayers: [imgLyr1.current],
        trailingLayers: [imgLyr2.current],
        position: 35, // set position of widget to 35%
        view: view1,
        visibleElements: {
          divider: true,
          handle: true, // handle will not display
        },
      });

      // add the widget to the view
      view1.ui.add(swipe);
      
      allViews.current.push(view1);
    }

    // set up the custom dynamic layer visible in second map
    if (mapDiv3.current) {
      let view3 = setupMap(mapDiv3.current);
      if (prevExtent) view3.extent = prevExtent; // set prev extent

      imgLyr3.current = new ImageryComparisonLayer({
        preLayer: imgLyr1.current,
        postLayer: imgLyr2.current,
        getTilesData: false, // no need to get tiles at this point
        mode: variableValue,
        temperatureUnit: selectedTemperatureUnit.current,
        newScaledRedPixelValue,
        newScaledBluePixelValue,
        newScaledGreenPixelValue,
        newScaledNegRedPixelValue,
      });

      view3.map.layers.add(imgLyr3.current, 0);

      imgLyr3.current.when(() => {
        // set first time only
        // set to first layers extent - since the custom layer extent will be zoomed out
        if (!prevExtent) view3.extent = imgLyr1.current.fullExtent; //imgLyr3.current.fullExtent;
      });

      // watchUtils.whenFalse(view3, 'updating', (val) => {
      //   // console.log("whenFalse view3 ")
      //   setIsLoading(false);

      //   // only update chart when comparison layer is updated
      //   // if (imgLyr3.current?.histogramValuesForTiles?.length > 0 && imgLyr3.current?.getTilesData) {
      //   //   // console.log("Sending " + imgLyr3.current.histogramValuesForTiles.length + " pixel values to chart..." )
      //   //   setChartData([...imgLyr3.current.histogramValuesForTiles])
      //   // }
      // })

      watchUtils.whenTrue(view3, "updating", (val) => {
        // console.log("whenTrue view3 ")
        setIsLoading(true);
      });

      view3.on("click", (evt) => handleMapClick(evt));
      
      // Legend placeholder
      const canvas2Elem = document.createElement("canvas")
      canvas2Elem.setAttribute('id', 'canvas2')
      canvas2Elem.setAttribute('width', '113em')
      canvas2Elem.setAttribute('height', '115em')
      ctx_2.current = canvas2Elem.getContext('2d');
      
      let expand2 = new Expand({
        expandIconClass: "esri-icon-legend",
        view: view3,
        content: canvas2Elem
      });
      view3.ui.add(expand2, "top-left");
            
      allViews.current.push(view3);
    }

    // set up the multi-bands layers for chart (Not added to map)
    // Single Model Yearly - 150-bands
    imgLyr_SingleModelYearly_150Bands.current = null;
    let tmpYearly150Bands = new ImageryTileLayer({
      url:
        variableValue <= 2
          ? TEMPERATURE_URL_SINGLE_MODEL_YEARLY_150_BANDS
          : PRECIPITATION_URL_SINGLE_MODEL_YEARLY_150_BANDS,
    });
    tmpYearly150Bands.load().then(() => {
      imgLyr_SingleModelYearly_150Bands.current = tmpYearly150Bands;
    });

    // Single Model Average - 120-bands
    imgLyr_SingleModelAvg_120Bands.current = null;
    let tmpAvg120Bands = new ImageryTileLayer({
      url:
        variableValue <= 2
          ? TEMPERATURE_URL_SINGLE_MODEL_AVG_120_BANDS
          : PRECIPITATION_URL_SINGLE_MODEL_AVG_120_BANDS,
    });
    tmpAvg120Bands.load().then(() => {
      imgLyr_SingleModelAvg_120Bands.current = tmpAvg120Bands;
    });

    // 4-Model Avg - 120-bands
    imgLyr_4ModelEnsemble_120Bands.current = null;
    let tmp4ModelEnsemble120Bands = new ImageryTileLayer({
      url:
        variableValue <= 2
          ? TEMPERATURE_URL_4_MODEL_ENSEMBLE_120_BANDS
          : PRECIPITATION_URL_4_MODEL_ENSEMBLE_120_BANDS,
    });
    tmp4ModelEnsemble120Bands.load().then(() => {
      imgLyr_4ModelEnsemble_120Bands.current = tmp4ModelEnsemble120Bands;
    });
  };

  const retrieveDateDropdownValues = (modelVal) => {
    if (!modelVal || modelVal.length <= 0) return null;

    if (modelVal === "10 MODEL ENSEMBLE")
      return yearsDropdown10ModelEnsemble.current;
    else if (modelVal === "4 MODEL ENSEMBLE")
      return yearsDropdown10ModelEnsemble.current.concat(
        yearsDropdown4ModelEnsemble.current
      );
    else if (modelVal.endsWith(" Avg"))
      return yearsDropdown10ModelEnsemble.current.concat(
        yearsDropdownSingleModelAverage.current
      );
    else return yearsDropdownSingleModelIndividual.current; //individual years
  };

  var newScaledRedPixelValue = scaleLinear()
    .domain([0, renderRangeMax.current])
    .range([0, 1]);

  var newScaledBluePixelValue = scaleLinear()
    .domain([renderRangeMin.current, 0])
    .range([0, 1]);

  var newScaledGreenPixelValue = scaleLinear()
    .domain([0, renderRangeMax.current])
    .range([0.2, 1]);

  var newScaledNegRedPixelValue = scaleLinear()
    .domain([renderRangeMin.current, 0])
    .range([0, 1]);

  const handleMapClick = (evt) => {
    clickedMapPoint.current = evt.mapPoint;
    let el = document.getElementById("compare-btn");

    // if (compareButtonDisable) {
    if (el.hasAttribute("disabled")) {
      identifyPixel(clickedMapPoint.current);
    } else {
      // compare button is enabled - show dialog
      setShowMapClickDialog(true);
    }
  };

  const identifyPixel = (mapPoint) => {
    imgLyr1.current
      .identify(mapPoint, {
        multidimensionalDefinition: imgLyr1.current.multidimensionalDefinition,
      })
      .then((result) => {
        let val =
          selectedVariable.current[0] === 3
            ? result.value
            : selectedTemperatureUnit.current === "F"
            ? kelvinToFahrenheit(result.value)
            : kelvinToCelsius(result.value);

        setSelectedPixelValue1(val);
      });

    imgLyr2.current
      .identify(mapPoint, {
        multidimensionalDefinition: imgLyr2.current.multidimensionalDefinition,
      })
      .then((result) => {
        let val =
          selectedVariable.current[0] === 3
            ? result.value
            : selectedTemperatureUnit.current === "F"
            ? kelvinToFahrenheit(result.value)
            : kelvinToCelsius(result.value);

        setSelectedPixelValue2(val);
      });

    addPin(mapPoint);
    setTimeSeriesChartData({});
    setupTimeSeriesChart(mapPoint);
  };

  const handleHoverDataFromChart = (hoverColumnMin, hoverColumnMax) => {
    // console.log(hoverColumnMin + "  " + hoverColumnMax)

    imgLyr3.current.getTilesData = false;
    imgLyr3.current.isHistogramHover = true;
    imgLyr3.current.hoverRange = { min: hoverColumnMin, max: hoverColumnMax };
    imgLyr3.current.refresh();
  };

  const handleClearHoverDataFromChart = () => {
    imgLyr3.current.getTilesData = false;
    imgLyr3.current.isHistogramHover = false;
    imgLyr3.current.hoverRange = {};
    imgLyr3.current.refresh();
  };

  const setupTimeSeriesChart = async (pt) => {
    setTimeSeriesChartUpdating(true);
    let timeChartData = [];
    let color1 = "#FFFF4A";
    let color2 = "#E09DBA"; //'#E063CE' //'#E4BAF7'
    let marker1 = "triangle";
    let marker2 = "circle";

    let values1, values2;
    let calAdaptValues1 = null,
      calAdaptValues2 = null;
    switch (selectedModel1.current[0]) {
      case 1:
        values1 = chartValuesSingleModelYearly(
          pt,
          imgLyr_SingleModelYearly_150Bands.current,
          selectedScenario1.current,
          selectedModel1.current,
          color1,
          marker1
        );
        if (selectedVariable.current[0] === 1) {
          calAdaptValues1 = getCalAdaptValues(
            pt,
            selectedScenario1.current,
            selectedModel1.current[1],
            color1,
            marker1
          );
        } else if (selectedVariable.current[0] === 3) {
          calAdaptValues1 = getCalAdaptPrecipitationValues(
            pt,
            selectedScenario1.current,
            selectedModel1.current[1],
            color1,
            marker1
          );
        }
        break;
      case 2:
        values1 = chartValuesSingleModelAverage(
          pt,
          imgLyr_SingleModelAvg_120Bands.current,
          selectedScenario1.current,
          selectedModel1.current,
          color1,
          marker1
        );
        if (selectedVariable.current[0] === 1) {
          calAdaptValues1 = getCalAdaptValues(
            pt,
            selectedScenario1.current,
            selectedModel1.current[1],
            color1,
            marker1
          );
        } else if (selectedVariable.current[0] === 3) {
          calAdaptValues1 = getCalAdaptPrecipitationValues(
            pt,
            selectedScenario1.current,
            selectedModel1.current[1],
            color1,
            marker1
          );
        }
        break;
      case 4:
        values1 = chartValues4ModelEnsemble(
          pt,
          imgLyr_4ModelEnsemble_120Bands.current,
          selectedScenario1.current,
          color1,
          marker1
        );
        break;
      case 10:
        values1 = chartValues10ModelEnsemble(
          pt,
          imgLyr1.current,
          selectedScenario1.current,
          color1,
          marker1
        );
        break;
      default:
      //nothing
    }

    switch (selectedModel2.current[0]) {
      case 1:
        values2 = chartValuesSingleModelYearly(
          pt,
          imgLyr_SingleModelYearly_150Bands.current,
          selectedScenario2.current,
          selectedModel2.current,
          color2,
          marker2
        );
        if (selectedVariable.current[0] === 1) {
          calAdaptValues2 = getCalAdaptValues(
            pt,
            selectedScenario2.current,
            selectedModel2.current[1],
            color2,
            marker2
          );
        } else if (selectedVariable.current[0] === 3) {
            calAdaptValues2 = getCalAdaptPrecipitationValues(
              pt,
              selectedScenario2.current,
              selectedModel2.current[1],
              color2,
              marker2
            );
        }        
        break;
      case 2:
        values2 = chartValuesSingleModelAverage(
          pt,
          imgLyr_SingleModelAvg_120Bands.current,
          selectedScenario2.current,
          selectedModel2.current,
          color2,
          marker2
        );
        if (selectedVariable.current[0] === 1) {
          calAdaptValues2 = getCalAdaptValues(
            pt,
            selectedScenario2.current,
            selectedModel2.current[1],
            color2,
            marker2
          );
        } else if (selectedVariable.current[0] === 3) {
          calAdaptValues2 = getCalAdaptPrecipitationValues(
            pt,
            selectedScenario2.current,
            selectedModel2.current[1],
            color2,
            marker2
          );
        }      
        break;
      case 4:
        values2 = chartValues4ModelEnsemble(
          pt,
          imgLyr_4ModelEnsemble_120Bands.current,
          selectedScenario2.current,
          color2,
          marker2
        );
        break;
      case 10:
        values2 = chartValues10ModelEnsemble(
          pt,
          imgLyr2.current,
          selectedScenario2.current,
          color2,
          marker2
        );        
        break;
      default:
      //nothing
    }

    Promise.all([values1, values2, calAdaptValues1, calAdaptValues2]).then(
      (results) => {
        timeChartData = [
          ...results[0],
          ...results[1],
          ...(results[2] ? results[2] : []),
          ...(results[3] ? results[3] : [])
        ];

        // set all attributes for TimeSeriesLine here i/o in JSX - so they are always in sync
        // with the maps and not any changes in the dropdown before 'Compare' is clicked
        setTimeSeriesChartData({
          ...{
            chartData: [...timeChartData],
            yAxisLabelPrimary:
              selectedVariable.current[0] === 3
                ? "Precipitation (mm/d)"
                : selectedTemperatureUnit.current === "F"
                ? "Temperature - Fahrenheit"
                : "Temperature - Celsius",
            yAxisLabelSecondary: results[2] || results[3] ? selectedVariable.current[0] === 3 ? "Extreme Precipitation (inches)" :
                                  selectedVariable.current[0] === 1 ? "Heat Days" : ""  : ""
          },
        });
      }
    );

    setTimeSeriesChartUpdating(false);
  };

  const chartValuesSingleModelYearly = async (
    pt,
    lyr,
    scenarioVal,
    modelVal,
    colorVal,
    markerVal
  ) => {
    // the variable naming convention in the 1-band layer in the map eg "CNRM-CM5 average maximum RCP 4.5"
    // is different from the 150-band layer eg "CNRM-CM5 Maximum Temperature RCP 4.5"
    // below is workaround for that so can query by multidim info
    let tmpVariableName =
      selectedVariable.current[0] === 1
        ? "Maximum Temperature"
        : selectedVariable.current[0] === 2
        ? "Minimum Temperature"
        : selectedVariable.current[0] === 3
        ? "Average Precipitation mm"
        : "";

    // get new Multidimensional name for 150-band layer
    let multidimName =
      scenarioVal?.length > 0 && modelVal[1]?.length > 0
        ? `${modelVal[1]} ${tmpVariableName} ${scenarioVal}`
        : "";

    // only need to query on variable/model/scenario and not year (specifying 1.0 as year to be in sync with the layer)
    // eg query [{variableName:"MIROC5 Maximum Temperature RCP 8.5",dimensionName:"fake_dimension",values:[1.0]}]
    let multidimInfo = [
      {
        variableName: multidimName,
        dimensionName: "fake_dimension",
        values: [1.0],
      },
    ];
    return await valuesFromMultiBandLayer(pt, lyr, multidimInfo).then(
      (values) => {
        // data format is array of arrays - each array is [x,y]
        let seriesVal = [];
        let beginYear = 1950; // until 2099;
        if (selectedVariable.current[0] <= 2) {
          // convert to selected temperature unit
          if (selectedTemperatureUnit.current === "F")
            seriesVal = values.map((val, idx) => [
              beginYear + idx,
              kelvinToFahrenheit(val),
            ]);
          else
            seriesVal = values.map((val, idx) => [
              beginYear + idx,
              kelvinToCelsius(val),
            ]);
        } else {
          // precipitation , no unit conversion needed
          seriesVal = values.map((val, idx) => [
            beginYear + idx,
            Number(val.toFixed(3)),
          ]);
        }
        return [
          {
            name: `${modelVal[1]} ${tmpVariableName} ${scenarioVal} -Yearly`,
            data: seriesVal,
            marker: {
              enabled: false,
              symbol: markerVal,
              fillColor: colorVal,
              lineWidth: 2,
              lineColor: colorVal, // inherit from series
            },
            color: colorVal,
          },
        ];
      }
    );
  };

  const chartValuesSingleModelAverage = async (
    pt,
    lyr,
    scenarioVal,
    modelVal,
    colorVal,
    markerVal
  ) => {
    let tmpVariableName =
      selectedVariable.current[0] === 1
        ? "_Maximum_Temperature_"
        : selectedVariable.current[0] === 2
        ? "_Minimum_Temperature_"
        : selectedVariable.current[0] === 3
        ? "_Average_Precipitation_"
        : "";

    let tmpScenarioName =
      scenarioVal === "RCP 4.5"
        ? "RCP_4.5"
        : scenarioVal === "RCP 8.5"
        ? "RCP_8.5"
        : "";

    let tmpModel = modelVal[1].slice(0, -4);

    // get new Multidimensional name for 120-band layer
    let multidimName =
      scenarioVal.length > 0 && modelVal[1]?.length > 0
        ? `${tmpModel}${tmpVariableName}${tmpScenarioName}`
        : "";

    // only need to query on variable/model/scenario and not year (specifying 1.0 as year to be in sync with the layer)
    let multidimInfo = [
      {
        variableName: multidimName,
        dimensionName: "fake_dimension",
        values: [1.0],
      },
    ];

    return await valuesFromMultiBandLayer(pt, lyr, multidimInfo).then(
      (values) => {
        // data format is array of arrays - each array is [x,y]
        let seriesVal = [];
        let beginYear = 1964; // until 2084
        if (selectedVariable.current[0] <= 2) {
          // convert to selected temperature unit
          if (selectedTemperatureUnit.current === "F")
            seriesVal = values.map((val, idx) => [
              beginYear + idx,
              kelvinToFahrenheit(val),
            ]);
          else
            seriesVal = values.map((val, idx) => [
              beginYear + idx,
              kelvinToCelsius(val),
            ]);
        } else {
          // precipitation , no unit conversion needed
          seriesVal = values.map((val, idx) => [
            beginYear + idx,
            Number(val.toFixed(3)),
          ]);
        }
        return [
          {
            name: `${multidimName.replaceAll("_", " ")} -Average`,
            data: seriesVal,
            marker: {
              enabled: false,
              symbol: markerVal,
              fillColor: colorVal,
              lineWidth: 2,
              lineColor: colorVal, // inherit from series
            },
            color: colorVal,
          },
        ];
      }
    );
  };

  const chartValues4ModelEnsemble = async (
    pt,
    lyr,
    scenarioVal,
    colorVal,
    markerVal
  ) => {
    let tmpVariableName =
      selectedVariable.current[0] === 1
        ? "Maximum_Temperature_"
        : selectedVariable.current[0] === 2
        ? "Minimum_Temperature_"
        : selectedVariable.current[0] === 3
        ? "Average_Precipitation_"
        : "";

    let tmpScenarioName =
      scenarioVal === "RCP 4.5"
        ? "RCP_4.5"
        : scenarioVal === "RCP 8.5"
        ? "RCP_8.5"
        : "";

    let multidimName = `${tmpVariableName}${tmpScenarioName}`;
    let multidimInfo = [
      {
        variableName: multidimName,
        dimensionName: "fake_dimension",
        values: [1.0],
      },
    ];

    return await valuesFromMultiBandLayer(pt, lyr, multidimInfo).then(
      (values) => {
        // data format is array of arrays - each array is [x,y]
        let seriesVal = [];
        let beginYear = 1964; // until 2084
        if (selectedVariable.current[0] <= 2) {
          // convert to selected temperature unit
          if (selectedTemperatureUnit.current === "F")
            seriesVal = values.map((val, idx) => [
              beginYear + idx,
              kelvinToFahrenheit(val),
            ]);
          else
            seriesVal = values.map((val, idx) => [
              beginYear + idx,
              kelvinToCelsius(val),
            ]);
        } else {
          // precipitation , no unit conversion needed
          seriesVal = values.map((val, idx) => [
            beginYear + idx,
            Number(val.toFixed(3)),
          ]);
        }
        return [
          {
            name: `4 Model Ensemble ${multidimName.replaceAll("_", " ")}`,
            data: seriesVal,
            marker: {
              enabled: false,
              symbol: markerVal,
              fillColor: colorVal,
              lineWidth: 2,
              lineColor: colorVal, // inherit from series
            },
            color: colorVal,
          },
        ];
      }
    );
  };

  const chartValues10ModelEnsemble = async (
    pt,
    lyr,
    scenarioVal,
    colorVal,
    markerVal
  ) => {
    let tmpVariableName =
      selectedVariable.current[0] === 1
        ? "Maximum_Temperature_"
        : selectedVariable.current[0] === 2
        ? "Minimum_Temperature_"
        : selectedVariable.current[0] === 3
        ? "Average_Precipitation_"
        : "";

    let tmpScenarioName =
      scenarioVal === "RCP 4.5"
        ? "RCP_4.5"
        : scenarioVal === "RCP 8.5"
        ? "RCP_8.5"
        : "";

    let multidimName = `${tmpVariableName}${tmpScenarioName}`;

    // why is multiple year values only getting first result ?
    // lyr.identify(
    //   pt, {
    //   multidimensionalDefinition: [{variableName: multidimName, dimensionName:"StdTime",values:[157766400000, 2493072000000, 3597523200000]}]
    // }).then( (vals) => console.log(vals))

    let historicBaseline = lyr.identify(pt, {
      multidimensionalDefinition: [
        {
          variableName: multidimName,
          dimensionName: "StdTime",
          values: [157766400000],
        },
      ],
    });

    let midCentury = lyr.identify(pt, {
      multidimensionalDefinition: [
        {
          variableName: multidimName,
          dimensionName: "StdTime",
          values: [2493072000000],
        },
      ],
    });

    let endOfCentury = lyr.identify(pt, {
      multidimensionalDefinition: [
        {
          variableName: multidimName,
          dimensionName: "StdTime",
          values: [3597523200000],
        },
      ],
    });

    //  [['1975 (1961-1990)', 157766400000],
    //  ['2049 (2035-2064)', 2493072000000],
    //  ['2084 (2070-2099)', 3597523200000]

    return Promise.all([historicBaseline, midCentury, endOfCentury]).then(
      (results) => {
        let baselineVal = Number(results[0].value[0].toFixed(3));
        let midCenturyVal = Number(results[1].value[0].toFixed(3));
        let endOfCenturyVal = Number(results[2].value[0].toFixed(3));

        // data format is array of arrays - each array is [x,y]
        let baselineSeries = [];
        let midCenturySeries = [];
        let endOfCenturySeries = [];

        if (selectedVariable.current[0] <= 2) {
          // convert to selected temperature unit
          let convertedBaselineVal =
            selectedTemperatureUnit.current === "F"
              ? kelvinToFahrenheit(baselineVal)
              : kelvinToCelsius(baselineVal);
          let convertedMidCenturyVal =
            selectedTemperatureUnit.current === "F"
              ? kelvinToFahrenheit(midCenturyVal)
              : kelvinToCelsius(midCenturyVal);
          let convertedEndOfCenturyVal =
            selectedTemperatureUnit.current === "F"
              ? kelvinToFahrenheit(endOfCenturyVal)
              : kelvinToCelsius(endOfCenturyVal);

          // baseline
          for (let i = 1961; i <= 1990; i++) {
            baselineSeries.push([i, convertedBaselineVal]);
          }

          // midCentury
          for (let i = 2035; i <= 2064; i++) {
            midCenturySeries.push([i, convertedMidCenturyVal]);
          }

          // endOfCentury
          for (let i = 2070; i <= 2099; i++) {
            endOfCenturySeries.push([i, convertedEndOfCenturyVal]);
          }
        } else {
          // precipitation , no unit conversion needed
          // baseline
          for (let i = 1961; i <= 1990; i++) {
            baselineSeries.push([i, baselineVal]);
          }

          // midCentury
          for (let i = 2035; i <= 2064; i++) {
            midCenturySeries.push([i, midCenturyVal]);
          }

          // endOfCentury
          for (let i = 2070; i <= 2099; i++) {
            endOfCenturySeries.push([i, endOfCenturyVal]);
          }
        }

        const styleInfo = {
          marker: {
            enabled: false,
            symbol: markerVal,
            fillColor: colorVal,
            lineWidth: 2,
            lineColor: colorVal, // inherit from series
          },
          color: colorVal,
        };

        const updtLabel = multidimName.replaceAll("_", " ");
        return [
          {
            name: `Historic Baseline ${updtLabel}`,
            data: baselineSeries,
            ...styleInfo,
          },
          {
            name: `Mid Century ${updtLabel}`,
            data: midCenturySeries,
            ...styleInfo,
          },
          {
            name: `End of Century ${updtLabel}`,
            data: endOfCenturySeries,
            ...styleInfo,
          },
        ];
      }
    );
  };

  const valuesFromMultiBandLayer = (pt, lyr, multidimensionalDefinition) => {
    return lyr
      .identify(pt, {
        multidimensionalDefinition: multidimensionalDefinition,
      })
      .then((result) => {
        return result.value;
      });
  };

  const getCalAdaptValues = (
    pt,
    scenarioVal,
    modelVal,
    colorVal,
    markerVal
  ) => {
    // eg https://api.cal-adapt.org/api/series/tasmax_day_CanESM2_rcp45/exheat/?g=POINT%28-121.46+38.59%29&freq=A

    let tmpModel = modelVal.endsWith(" Avg")
      ? modelVal.slice(0, modelVal.length - 4)
      : modelVal;
    let model_scenario =
      tmpModel + "_rcp" + scenarioVal.slice(4).replace(".", ""); // remove 'RCP ' and '.' from string

    let url = `https://api.cal-adapt.org/api/series/tasmax_day_${model_scenario}/exheat/?g=POINT(${pt.longitude}+${pt.latitude})&freq=A`;

    return fetch(url)
      .then((res) => res.json())
      .then((result) => {
        // object with format date:days
        let counts = result.counts;
        let seriesVal = Object.keys(counts).map((ky) => [
          Number(ky.slice(0, 4)),
          counts[ky],
        ]);

        return [
          {
            name: `CalAdapt ${tmpModel} ${scenarioVal}`,
            data: seriesVal,
            marker: {
              enabled: false,
              symbol: markerVal,
              fillColor: colorVal,
              lineWidth: 2,
              lineColor: colorVal,
            },
            color: colorVal,
            dashStyle: "Dot", //'Dash',
            yAxis: 1,
          },
        ];
      });
  };
  
  const getCalAdaptPrecipitationValues = (
    pt,
    scenarioVal,
    modelVal,
    colorVal,
    markerVal
    ) => {
    // eg https://api.cal-adapt.org/api/series/pr_day_CanESM2_rcp85/pot/?g=POINT%28-121.46+38.59%29&intervals=100
    
    let tmpModel = modelVal.endsWith(" Avg")
      ? modelVal.slice(0, modelVal.length - 4)
      : modelVal;
    let model_scenario =
      tmpModel + "_rcp" + scenarioVal.slice(4).replace(".", ""); // remove 'RCP ' and '.' from string

    let url = `https://api.cal-adapt.org/api/series/pr_day_${model_scenario}/pot/?g=POINT(${pt.longitude}+${pt.latitude})&intervals=100`;

    return fetch(url)
      .then((res) => res.json())
      .then((result) => {
        // array of 3 objects
        let returnlevels = result.returnlevels;
        
        // data format for chart is array of arrays - each array is [x,y]
        let valueSeries = [];
        let lowerciSeries = [];
        let upperciSeries = [];
              
        for (let lvl = 0; lvl < returnlevels.length; lvl++) {    
          let returnLvl = returnlevels[lvl] 
          
          // fill null values for years not sent back in api
          // so line can be a single series but disconnected
          if (lvl > 0 ) {
            for (let i = Number(returnlevels[lvl-1].end.slice(0,4)) + 1 ; i < Number(returnLvl.begin.slice(0,4)) ; i++) {
              valueSeries.push([i, null])
              lowerciSeries.push([i, null])
              upperciSeries.push([i, null])
            }
          }          
                 
          let levelInfo = returnLvl.levels[0]  // only one object as query is for intervals=100
          for (let i = Number(returnLvl.begin.slice(0,4)); i <= Number(returnLvl.end.slice(0,4)); i++) {
            valueSeries.push([i, Number(levelInfo.value.toFixed(3))]);
            lowerciSeries.push([i, Number(levelInfo.lowerci.toFixed(3))]);
            upperciSeries.push([i, Number(levelInfo.upperci.toFixed(3))]);            
          }         
        }           
        
        const styleInfo = {
          marker: {
            enabled: false,
            symbol: markerVal,
            fillColor: colorVal,
            lineWidth: 2,
            lineColor: colorVal,
          },
          color: colorVal,
          yAxis: 1,
        };
        
        return [
          {
            name: `CalAdapt Precipitation ${tmpModel} ${scenarioVal} - Estimated Return Level`,
            data: valueSeries,
            ...{ ...styleInfo, dashStyle:"Solid" }
          },
          {
            name: `CalAdapt Precipitation ${tmpModel} ${scenarioVal} - Lower Confidence Interval`,
            data: lowerciSeries,
            ...{ ...styleInfo, dashStyle:"Dot" }
          },
          {
            name: `CalAdapt Precipitation ${tmpModel} ${scenarioVal} - Upper Confidence Interval`,
            data: upperciSeries,
            ...{ ...styleInfo, dashStyle:"Dash" }
          },
        ];
        
      });
  }

  const addPin = (pt) => {
    const pinForMap = new Graphic({
      geometry: pt,
      symbol: pinTextSymbol,
    });

    for (let view of allViews.current) {
      view.graphics.removeAll();
      view.graphics.add(pinForMap);
    }
  };

  const onCompareButtonClicked = (evt) => {
    storeAllValues();

    // reset any layer dependent value
    setSelectedPixelValue1(0);
    setSelectedPixelValue2(0);

    for (let view of allViews.current) {
      view.graphics.removeAll();
    }
    setTimeSeriesChartData({});

    if (resetMapLayers.current === true) {
      resetMaps();
      resetMapLayers.current = false;
    }

    updateImageLayer1();
    updateImageLayer2();

    updateDynamicLegend.current = true
    
    // re-apply pin and timechart for existing layers
    if (imgLyr1.current.loaded && imgLyr2.current.loaded) {
      if (clickedMapPoint.current) identifyPixel(clickedMapPoint.current);
      // recreate static legend in case temperature unit has changed for existing layers
      let minVal = Math.min(imgLyr1.current.rasterInfo.statistics[0].min, imgLyr2.current.rasterInfo.statistics[0].min)
      let maxVal = Math.max(imgLyr1.current.rasterInfo.statistics[0].max, imgLyr2.current.rasterInfo.statistics[0].max)
      createStaticLegend(minVal, maxVal)
    }
    
    setCompareButtonDisable(true);
  };

  const storeAllValues = () => {
    // check if diff layer has to be loaded
    let prevVariable = selectedVariable.current;
    selectedVariable.current = getVariable();

    // 1,2 is temperature layer , 3 is precip layer
    // if switched between Min/Max Temperature and precipitation
    if (
      (prevVariable[0] <= 2 && selectedVariable.current[0] > 2) ||
      (prevVariable[0] === 3 && selectedVariable.current[0] !== 3)
    ) {
      resetMapLayers.current = true;
    }

    selectedScenario1.current = getScenario(scenarioSelection1.current);
    selectedScenario2.current = getScenario(scenarioSelection2.current);

    // check if diff layer has to be loaded
    let prevModel1 = selectedModel1.current;
    selectedModel1.current = getModel(modelSelection1.current);
    let prevModel2 = selectedModel2.current;
    selectedModel2.current = getModel(modelSelection2.current);

    // if switched between models, but if model ID matches , no need to load diff layer
    if (
      prevModel1[0] !== selectedModel1.current[0] ||
      prevModel2[0] !== selectedModel2.current[0]
    ) {
      resetMapLayers.current = true;
    }

    selectedYear1.current = getYear(timeSelection1.current);
    selectedYear2.current = getYear(timeSelection2.current);
    selectedTemperatureUnit.current = getTemperatureUnit();

    // reset
    variableChanged.current = false;
    scenario1Changed.current = false;
    scenario2Changed.current = false;
    model1Changed.current = false;
    model2Changed.current = false;
    year1Changed.current = false;
    year2Changed.current = false;
    temperatureUnitChanged.current = false;
  };

  const closeMapClickDialog = () => {
    setShowMapClickDialog(false);
  };
  
  const updateDifferenceLegend = () => {
    ctx_2.current.clearRect(0, 0, ctx_2.current.canvas.width, ctx_2.current.canvas.height);
    ctx_2.current.fillStyle = "#2b2b2b";      
    ctx_2.current.fillRect(0, 0 , ctx_2.current.canvas.width, ctx_2.current.canvas.height);                
    
    //mkae deep copy as 'sort' affects current array
    let tmp = JSON.parse(JSON.stringify(imgLyr3.current.histogramValuesForTiles)) 
    tmp.sort((a, b)=>  {
      return a.y - b.y;
    }); 
    
    let uniqVals = new Set(tmp.map( v => v.y)) 
    let numOfSteps = Math.ceil(uniqVals.size/200) < 5 ? Math.ceil(uniqVals.size/100) : Math.ceil(uniqVals.size/200)
    
    // calc for 100/200 colors + 2 (for center point and end point(since Math.ceil is used))
    let rectHeight = Math.ceil(uniqVals.size/200) < 5 ? colorRampHeight/102 : colorRampHeight/202
    
    let uniqArr = []
    for (let val of uniqVals.values()) {
      let item = tmp.find(obj => obj.y === val)
      uniqArr.push(item)
    }
    
    let starty = colorRampStartY    
    
    let arrLength = uniqArr.length
    let halfTick = Math.floor(arrLength/2)
    
    // remove dark background for color ramp to avoid dark lines displaying thru light red/green
    let bkgrdRect = colorRampStartY    
    for (let i = arrLength - 1; i >= 0 ; i --) {
      if (i === 0 || i === halfTick || i === arrLength - 1
        || i % numOfSteps === 0 ) {
          bkgrdRect += rectHeight
        }
    }
    ctx_2.current.fillStyle = "white";      
    ctx_2.current.fillRect(colorRampStartX, colorRampStartY , colorRampWidth, bkgrdRect - colorRampStartY);                
    
    let txtSuffix = selectedVariable.current[0] === 3 ? " mm/d" : 
                    selectedTemperatureUnit.current === "F" ? ' °F'
                    : ' °C';
                    
    let defaultFont = ctx_2.current.font.slice(ctx_2.current.font.indexOf('px'))
    let newFont = "12" + defaultFont
    ctx_2.current.font = newFont
    
    // let cnt = 0        
    for (let i = arrLength - 1; i >= 0 ; i --) {
      const obj = uniqArr[i]
      
      if (i === 0 || i === halfTick || i === arrLength - 1
        || i % numOfSteps === 0 ) {             
         
        // console.log(obj.y + ' = ' + obj.color + " , i= " + i + " , numOfSteps = " + numOfSteps + " starty = " + starty )  
        ctx_2.current.fillStyle = obj.color;      
        ctx_2.current.fillRect(colorRampStartX, starty , colorRampWidth, rectHeight);        
        
        if (i === 0 || i === halfTick || i === arrLength - 1) {
          // console.log(obj.y + ' = ' + obj.color + " , i= " + i + " text")  
          ctx_2.current.fillStyle = 'white';      
          if (i === 0) {
            ctx_2.current.fillText(obj.y + txtSuffix, colorRampStartX + colorRampWidth + 5, starty + 5 );
          } else {
            ctx_2.current.fillText(obj.y + txtSuffix, colorRampStartX + colorRampWidth + 5, starty + rectHeight/2 );
          }          
        }        
        
        starty += rectHeight
        
        // console.log("cnt = " + cnt + " starty = " + starty + " , i= " + i)
        // cnt++
      }      
    }
  }

  const createStaticLegend = (minVal, maxVal) => {
    ctx_1.current.fillStyle ="#2b2b2b";      
    ctx_1.current.fillRect(0, 0 , ctx_1.current.canvas.width, ctx_1.current.canvas.height);    
    
    let legendImg1 = new Image()
    legendImg1.src = selectedVariable.current[0] === 3 ? legend_map1_precipitation  : legend_map1_temperature
    legendImg1.onload = () => {
      ctx_1.current.drawImage(legendImg1, colorRampStartX, colorRampStartY) 
    }
    
    let defaultFont = ctx_1.current.font.slice(ctx_1.current.font.indexOf('px'))
    let newFont = "12" + defaultFont
    ctx_1.current.font = newFont
    ctx_1.current.fillStyle = 'white';
    
    if (selectedVariable.current[0] < 3) {
      minVal = selectedTemperatureUnit.current === "F" ? kelvinToFahrenheit(minVal) : kelvinToCelsius(minVal)
      maxVal = selectedTemperatureUnit.current === "F" ? kelvinToFahrenheit(maxVal) : kelvinToCelsius(maxVal)
    }     
    
    let offset = 5
    let meanVal = ((minVal + maxVal)/2).toFixed(0)
    let maxTxt = selectedVariable.current[0] === 3 ? maxVal.toFixed(0) + " mm/d" : maxVal.toFixed(0) + " °" + selectedTemperatureUnit.current    
    let centerTxt = selectedVariable.current[0] === 3 ? meanVal + " mm/d" : meanVal + " °" + selectedTemperatureUnit.current
    let minTxt = selectedVariable.current[0] === 3 ?  minVal.toFixed(0) + " mm/d" : minVal.toFixed(0) + " °" + selectedTemperatureUnit.current
    
    ctx_1.current.fillText(maxTxt, colorRampStartX + colorRampWidth + 5, colorRampStartY + offset);
    ctx_1.current.fillText(centerTxt, colorRampStartX + colorRampWidth + 5, colorRampStartY + offset + colorRampHeight/2);        
    ctx_1.current.fillText(minTxt, colorRampStartX + colorRampWidth + 5, colorRampStartY + + offset/2 + colorRampHeight);        
    
  }
  
  // const isLoading = !imgLyrView1.current || imgLyrView1.current.updating ||
  // !imgLyrView2.current || imgLyrView2.current.updating || timeSeriesChartUpdating

  return (
    <main className="main-container">
      <header className="header">
        <section className="branding">
          <img className="logo" src={CaLogo} alt="CA.gov" />
          <h2 className="title">Climate Explorer - DRAFT</h2>
        </section>

        <section>
          <InfoButton />
          {showMapClickDialog ? (
            <MapClickConfirm okHandler={closeMapClickDialog} />
          ) : null}
        </section>
      </header>

      <section className="main-grid">
        {/* {isLoading ? <calcite-scrim loading></calcite-scrim> : null } */}
        <div className="main-map">
          <div className="main-map-header">
            <span className="section-title">Base Layer</span>
            <span className="section-title" style={{ textAlign: "right" }}>
              Comparison Layer
            </span>
          </div>
          <div id="map1" ref={mapDiv1} className="mapDiv"></div>
        </div>

        <div className="compare-map">
          <div className="main-map-header">
            <span className="section-title">Difference: Comparison Layer – Base Layer</span>
          </div>
          <div id="compare-map" ref={mapDiv3} className="mapDiv"></div>
        </div>

        <div className="graph-content">
          <span className="section-title">Summary of differences</span>
          <calcite-label
            layout="inline"
            alignment="center"
            style={{ margin: "1rem 0 0" }}
          >
            <p>
              <strong>
                Layer Pixel Values
              </strong>
            </p>
          </calcite-label>
          <div className="stats">
            <calcite-label layout="inline" alignment="center">
              <p>Base Layer:</p>
              <p>
                <strong>
                  {Number(parseFloat(selectedPixelValue1).toFixed(1))}
                </strong>
              </p>
            </calcite-label>

            <calcite-label layout="inline" alignment="center">
              <p>Comparison Layer:</p>
              <p>
                <strong>
                  {Number(parseFloat(selectedPixelValue2).toFixed(1))}
                </strong>
              </p>
            </calcite-label>

            <calcite-label layout="inline" alignment="center">
              <p>Difference:</p>
              <p>
                <strong>
                  {Number(
                    (
                      parseFloat(selectedPixelValue2) -
                      parseFloat(selectedPixelValue1)
                    ).toFixed(1)
                  )}
                </strong>
              </p>
            </calcite-label>
          </div>

          <Histogram
            chartData={chartData}
            hoverDataHandler={handleHoverDataFromChart}
            clearHoverDataHandler={handleClearHoverDataFromChart}
            dataUnits={selectedVariable.current[0] === 3 ? "mm" :
            selectedTemperatureUnit.current === "F" ? "Fahrenheit"
            : "Celsius" }
          />
        </div>

        <div className="map-options">
          <span className="section-title">
            Select climate information to compare
          </span>
          <div className="sc-calcite-label sc-calcite-label-s calcite-theme-dark calcite-ui-text-2 menu-options-label-wrapper">
            <span className="menu-options-label">Variable</span>
            {variableListSelect(variableSelection, "average maximum")}
          </div>          
          
          <div style={{display: "flex"}}>
            <span className="span-sub-header" style= {{ marginLeft: "60px", paddingLeft: "1rem"}}>
                Base Layer
            </span>
            <span className="span-sub-header" >
                Comparison Layer
            </span>
          </div>

          <div className="sc-calcite-label sc-calcite-label-s calcite-theme-dark calcite-ui-text-2 menu-options-label-wrapper">
            <span className="menu-options-label">Scenario</span>
            {scenarioListSelect(scenarioSelection1, "RCP 4.5")}
            {scenarioListSelect(scenarioSelection2, "RCP 4.5")}
          </div>

          <div className="sc-calcite-label sc-calcite-label-s calcite-theme-dark calcite-ui-text-2 menu-options-label-wrapper">
            <span className="menu-options-label">Model</span>
            {modelListSelect(modelSelection1, "10 MODEL ENSEMBLE")}
            {modelListSelect(modelSelection2, "10 MODEL ENSEMBLE")}
          </div>

          <div className="sc-calcite-label sc-calcite-label-s calcite-theme-dark calcite-ui-text-2 menu-options-label-wrapper">
            <span className="menu-options-label">Year</span>
            <calcite-select
              title="Select time period"
              aria-label="Select time period"
              ref={timeSelection1}
              style={{ width: "100%" }}
            >
              {dateDropdownValues1}
            </calcite-select>
            <calcite-select
              title="Select time period"
              aria-label="Select time period"
              ref={timeSelection2}
              style={{ width: "100%" }}
            >
              {dateDropdownValues2}
            </calcite-select>
          </div>
          <div className="sc-calcite-label sc-calcite-label-s calcite-theme-dark calcite-ui-text-2 menu-options-label-wrapper">
            <span className="menu-options-label">Units &nbsp;&nbsp;</span>
            <calcite-radio-button-group
              name="temperature-unit-group"
              ref={temperatureUnitSelection}
              disabled={disableTemperatureUnit}
              style={{ marginTop: "10px" }}
            >
              <calcite-label layout="inline">
                <calcite-radio-button
                  value="F"
                  checked
                  disabled={disableTemperatureUnit}
                ></calcite-radio-button>
                Fahrenheit
              </calcite-label>
              <calcite-label layout="inline">
                <calcite-radio-button
                  value="C"
                  disabled={disableTemperatureUnit}
                ></calcite-radio-button>
                Celsius
              </calcite-label>
            </calcite-radio-button-group>
          </div>

          <calcite-button
            id="compare-btn"
            color="blue"
            label="Click to apply the updated selection of climate scenarios, variables, and models"
            aria-label="Click to apply the updated selection of climate scenarios, variables, and models"
            style={{ width: "9rem", alignSelf: "flex-end" }}
            onClick={(e) => onCompareButtonClicked(e)}
            {...(compareButtonDisable ? { disabled: true } : {})}
          >
            Compare
          </calcite-button>
        </div>

        <div className="timeline">
          <span className="section-title">Change over time for selected location</span>
          <TimeSeriesLine {...timeSeriesChartData} />
        </div>
      </section>
    </main>
  );
}

export default App;
